// Shared helpers for Dealership tabs — status colours, dictionaries, model lookup helper.
export const STATUS_COLOR = {
  new: "text-blue-500", contacted: "text-cyan-500",
  test_drive_scheduled: "text-purple-500", test_drive_done: "text-purple-600",
  quotation_sent: "text-amber-500", negotiation: "text-orange-500",
  converted: "text-emerald-600", lost: "text-red-500", junk: "text-muted-foreground",
  draft: "text-muted-foreground", sent: "text-blue-500", cancelled: "text-red-500",
  expired: "text-orange-500", booked: "text-blue-500", delivered: "text-emerald-600",
  in_transit: "text-amber-500", in_stock: "text-emerald-600", allocated: "text-purple-600",
  sold: "text-muted-foreground", demo: "text-cyan-500",
  waiting: "text-amber-500", arrived: "text-emerald-600",
  scheduled: "text-blue-500", pending: "text-amber-500",
  applied: "text-blue-500", approved: "text-emerald-600", rejected: "text-red-500",
  disbursed: "text-emerald-700",
  issued: "text-emerald-600", not_applicable: "text-muted-foreground", not_issued: "text-muted-foreground",
  open: "text-amber-500", in_progress: "text-blue-500", closed: "text-emerald-600", invoiced: "text-emerald-700",
};

export const SOURCES = ["walk_in", "website", "phone", "referral", "social_media", "expo", "other"];
export const LEAD_STATUSES = ["new", "contacted", "test_drive_scheduled", "test_drive_done",
                                "quotation_sent", "negotiation", "converted", "lost", "junk"];
export const DISCOUNT_CATS = [
  { key: "doctor", label: "Doctor" }, { key: "lawyer", label: "Lawyer" },
  { key: "rural", label: "Rural" }, { key: "loyalty", label: "Loyalty" },
];

export const INSURANCE_PLANS = [
  { key: "comprehensive", label: "Comprehensive" },
  { key: "third_party", label: "Third Party" },
  { key: "zero_dep", label: "Zero Depreciation" },
  { key: "standalone_od", label: "Standalone OD" },
];

export const INSURANCE_ADDONS = ["zero_dep", "engine_protect", "return_to_invoice",
                                   "roadside_assistance", "consumables", "key_replacement"];

export const modelName = (id, models) => {
  const m = (models || []).find((x) => x.id === id);
  return m ? `${m.name} · ${m.variant}` : "—";
};
